import React from "react";

import { ANALYTICS } from "../../analytics/constants";
import { CategoryProps } from "../../interfaces/category-interface";
import { StoreProps } from "../../interfaces/stores-interface";
import Grid from "../layout/grid";
import { Offer } from "../modals/offer";
import useOfferCallbacks from "../modals/offerCallbacks";
import { StoreTile } from "./store-tile";

type Props = {
    stores: Array<StoreProps>;
    analytics: ANALYTICS;
    category?: CategoryProps;
    parentCategory?: CategoryProps;
    featured?: boolean;
};

export const StoreTiles: React.FC<Props> = ({
    stores,
    analytics,
    category,
    parentCategory,
    featured,
}) => {
    const {
        isOfferModalsVisible,
        isOfferModalsFading,
        setOfferModalsVisible,
        setOfferModalsFading,
        offerButtonClickHandler,
    } = useOfferCallbacks(stores);

    const preview = stores.map((store, position) => (
        <React.Fragment key={store.id}>
            <StoreTile
                position={position}
                key={store.id}
                store={store}
                category={category}
                parentCategory={parentCategory}
                analytics={{
                    ...analytics,
                    eventProps: {
                        ...analytics.eventProps,
                        categoryId: category?.id,
                        categoryName: category?.name,
                    },
                }}
                offerButtonClickHandler={offerButtonClickHandler}
                featured={featured}
            />
            {isOfferModalsVisible[store.id] && (
                <Offer
                    store={store}
                    active={isOfferModalsFading[store.id]}
                    setVisibleCallback={setOfferModalsVisible}
                    setFadingCallback={setOfferModalsFading}
                    uiContext={analytics.uiContext}
                />
            )}
        </React.Fragment>
    ));

    return (
        <Grid fullWidth fullHeight>
            {preview}
        </Grid>
    );
};
